import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

// services
import * as JulevennerService from '../../../../services/bb-api/red-cross/julevenner';
import { notification } from 'antd';

export const OnlineNumbers: React.FC = () => {
	const [totalHostCount, setTotalHostCount] = useState(Number());
	const [totalGuestCount, setTotalGuestCount] = useState(Number());
	const [hostCount24h, setHostCount24h] = useState(Number());
	const [guestCount24h, setGuestCount24h] = useState(Number());
	const [matchCount, setmatchCount] = useState(Number());

	const getData = useCallback(() => {
		try {
			JulevennerService.totalPostCount('host', 0).then(setTotalHostCount);
			JulevennerService.totalPostCount('guest', 0).then(setTotalGuestCount);
			JulevennerService.postCount24h('host', 0).then(setHostCount24h);
			JulevennerService.postCount24h('guest', 0).then(setGuestCount24h);
			JulevennerService.matchCount(0).then(setmatchCount);
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [])

	useEffect(() => {
		getData();
		const intervalTime = 60 * 1000 // 1 min
		const intervalId = setInterval(getData, intervalTime)
		return () => clearInterval(intervalId)
	}, [getData]);

	return (
    <StyledContainer className='online-container'>
      <h1>Julevenner Online</h1>
      
      <div className='online-numbers-wrapper'>
        <div className='online-number-box'>
          <p>Antal tilmeldinger af værter:</p>
          <p>{totalHostCount}</p>
        </div>
        <div className='online-number-box'>
          <p>Antal tilmeldinger af gæster:</p>
          <p>{totalGuestCount}</p>
        </div>
        <div className='online-number-box'>
          <p>Antal færdige matches:</p>
          <p>{matchCount}</p>
        </div>
        <div className='online-number-box'>
          <p>Nye værter de sidste 24 timer:</p>
          <p>{hostCount24h}</p>
        </div>
        <div className='online-number-box'>
          <p>Nye gæster de sidste 24 timer:</p>
          <p>{guestCount24h}</p>
        </div>
      </div>
		</StyledContainer>
	);
};

const StyledContainer = styled.div`
	display: flex;
  flex-direction: column;
  margin: 0px 24px 24px 12px;
  padding: 24px;
  border-radius: 12px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
	background-color: rgba(255, 255, 255, 0.8);
	backdrop-filter: blur(10px);

	h1 {
		font-size: 48px;
		font-weight: 700;
		margin: 0 0 24px 24px;
	}

  .online-numbers-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;
  }

  .online-number-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    background-image: linear-gradient(to right, #fcfcfc , #f5fafa);
    border-radius: 6px;

    p { 
      margin: 0;
      font-size: 1.6em;
    }

    p:nth-child(2) {
      font-size: 2em;
      font-weight: bold;
    }
  }
`;
